import MainNavigationList from 'layouts/main-navigation-list/main-navigation-list';
import StorageInfo from 'components/storage-info/storage-info';

import { Container, Row, StyledFlex } from 'assets/styles/pages.style';

const MainNavigationBar = () => {
  return (
    <Container>
      <Row mb={5}>
        <StyledFlex>
          <MainNavigationList />
          <StorageInfo />
        </StyledFlex>
      </Row>
    </Container>
  );
};

export default MainNavigationBar;
